import React, { Component } from "react";
import { Link } from "react-router-dom";

// CSS
import "../../css/training/training-menu.css";

class TrainingMenuItem extends Component {
	render() {
		const { link, icon, title, content, footer } = this.props;

		return (
			<Link to={link} className="training-menu--item">
				{!!icon && (
					<div className="training-item--icon-wrapper">
						<div className={`icon-${icon}`} />
					</div>
				)}
				<div className="training-item--text">
					<h2>{title}</h2>
					<div className="txt">{content}</div>
				</div>
				{!!footer && <div className="training-item--footer">{footer}</div>}
			</Link>
		);
	}
}

export default TrainingMenuItem;



// WEBPACK FOOTER //
// ./src/components/training/TrainingMenuItem.js